import React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Container, Box, Typography } from '@mui/material';
import { LinkedIn } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import nataliaPhoto from '../../assets/img/author-natalia.jpg';

const DEFAULT_REVIEWER = {
  name: 'Natalia Duarte',
  role: 'Co-fundadora & Editora, FinMaple',
  linkedin: 'https://www.linkedin.com/in/natalia-duarteh/',
  photo: nataliaPhoto,
};

const EditorialReview = ({ reviewer = DEFAULT_REVIEWER, lastUpdated }) => {
  const { t } = useTranslation();
  const { lng } = useParams();
  const displayDate = lastUpdated || t('editorialReview.defaultDate');
  return (
  <Container maxWidth="lg" sx={{ py: { xs: 2, md: 3 } }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        bgcolor: '#F7F9FC',
        borderRadius: '12px',
        boxShadow: '0 6px 18px rgba(0,0,0,0.05)',
        px: { xs: 2, md: 3 },
        py: { xs: 1.5, md: 2 },
      }}
    >
      {/* Photo */}
      <Box
        component="img"
        src={reviewer.photo}
        alt={reviewer.name}
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          objectFit: 'cover',
          objectPosition: 'center 20%',
          border: '3px solid #FFFFFF',
          boxShadow: '0 0 0 1px #E2E8F0',
          flexShrink: 0,
        }}
      />

      {/* Text block */}
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Typography
            sx={{
              fontWeight: 600,
              color: '#1A1A1A',
              fontSize: '15px',
              lineHeight: 1.3,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {reviewer.name}
          </Typography>
          <Box
            component="a"
            href={reviewer.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: '#1E3A5F',
              flexShrink: 0,
              '&:hover': { opacity: 0.8 },
            }}
          >
            <LinkedIn sx={{ fontSize: 18 }} />
          </Box>
        </Box>

        <Typography
          sx={{
            color: '#5F6B7A',
            fontSize: '13px',
            lineHeight: 1.4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {reviewer.role}
        </Typography>

        <Typography
          sx={{
            color: '#5F6B7A',
            fontSize: '12px',
            lineHeight: 1.4,
            mt: 0.25,
          }}
        >
          {t('editorialReview.updated')}: {displayDate}
          {' · '}
          <Typography
            component={RouterLink}
            to={`/${lng}/como-monetizamos`}
            sx={{
              color: '#5F6B7A',
              fontSize: '12px',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            {t('editorialReview.methodology')}
          </Typography>
        </Typography>
      </Box>
    </Box>
  </Container>
  );
};

export default EditorialReview;
